import { fromUTC } from '@klp/helpers';

import { ByggKontraktGaranti } from './ByggKontraktGaranti';
import { ByggKontraktItem } from './ByggKontraktItem';
import type { IByggKontrakt } from './IByggKontrakt';
import type { IByggKontraktGaranti } from './IByggKontraktGaranti';

import type { IByggKontraktItem } from '.';

export class ByggKontrakt implements IByggKontrakt {
    public static parseObject(obj: IByggKontrakt): ByggKontrakt {
        try {
            return new ByggKontrakt(obj);
        } catch (error) {
            throw new Error(
                `Not able to parse Kontrakt object, object attempted to parse is: ${JSON.stringify(
                    obj,
                )}`,
            );
        }
    }

    public get antallEtasjer() {
        return this._antallEtasjer;
    }
    public get arligEiendomsskatt() {
        return this._arligEiendomsskatt;
    }
    public get arligFellesKostnad() {
        return this._arligFellesKostnad;
    }
    public get arligLeie() {
        return this._arligLeie;
    }
    public get bygningsNummer() {
        return this._bygningsNummer;
    }
    public get energiForbrukPrM2() {
        return this._energiForbrukPrM2;
    }
    public get felleskostnaderPrM2() {
        return this._felleskostnaderPrM2;
    }
    public get gyldigFra() {
        return this._gyldigFra;
    }
    public get gyldigTil() {
        return this._gyldigTil;
    }
    public get kontraktDetaljer() {
        return this._kontraktDetaljer;
    }
    public get kontraktFra() {
        return this._kontraktFra;
    }
    public get kontraktId() {
        return this._kontraktId;
    }
    public get kontraktTil() {
        return this._kontraktTil;
    }
    public get kontraktsdato() {
        return this._kontraktsdato;
    }
    public get kontraktsnummer() {
        return this._kontraktsnummer;
    }
    public get kostPrPplassPrAr() {
        return this._kostPrPplassPrAr;
    }
    public get kundeNummer() {
        return this._kundeNummer;
    }
    public get lokalValuta() {
        return this._lokalValuta;
    }
    public get kontraktGarantier() {
        return this._kontraktGarantier;
    }

    private _antallEtasjer: string;
    private _arligEiendomsskatt: number;
    private _arligFellesKostnad: number;
    private _arligLeie: number;
    private _bygningsNummer: string;
    private _energiForbrukPrM2: number;
    private _felleskostnaderPrM2: number;
    private _gyldigFra?: Date;
    private _gyldigTil?: Date;
    private _kontraktGarantier: Array<ByggKontraktGaranti>;
    private _kontraktDetaljer: Array<ByggKontraktItem>;
    private _kontraktFra?: Date;
    private _kontraktId: number;
    private _kontraktTil?: Date;
    private _kontraktsdato?: Date;
    private _kontraktsnummer: string;
    private _kostPrPplassPrAr: number;
    private _kundeNummer: string;
    private _lokalValuta: string;

    constructor(obj: IByggKontrakt) {
        this._antallEtasjer = obj.antallEtasjer;
        this._arligEiendomsskatt = obj.arligEiendomsskatt;
        this._arligFellesKostnad = obj.arligFellesKostnad;
        this._arligLeie = obj.arligLeie;
        this._bygningsNummer = obj.bygningsNummer;
        this._energiForbrukPrM2 = obj.energiForbrukPrM2;
        this._felleskostnaderPrM2 = obj.felleskostnaderPrM2;
        this._gyldigFra = obj.gyldigFra ? fromUTC(obj.gyldigFra) : undefined;
        this._gyldigTil = obj.gyldigTil ? fromUTC(obj.gyldigTil) : undefined;
        this._kontraktGarantier = obj.kontraktGarantier.map(
            (item: IByggKontraktGaranti) =>
                ByggKontraktGaranti.parseObject(item),
        );
        this._kontraktDetaljer = obj.kontraktDetaljer.map(
            (item: IByggKontraktItem) => ByggKontraktItem.parseObject(item),
        );
        this._kontraktFra = obj.kontraktFra
            ? fromUTC(obj.kontraktFra)
            : undefined;
        this._kontraktId = obj.kontraktId;
        this._kontraktTil = obj.kontraktTil
            ? fromUTC(obj.kontraktTil)
            : undefined;
        this._kontraktsdato = obj.kontraktsdato
            ? fromUTC(obj.kontraktsdato)
            : undefined;
        this._kontraktsnummer = obj.kontraktsnummer;
        this._kostPrPplassPrAr = obj.kostPrPplassPrAr;
        this._kundeNummer = obj.kundeNummer;
        this._lokalValuta = obj.lokalValuta;
    }
}
